import { SVGProps } from "react";

export const AddChannelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M14 11H11M11 11H8M11 11V8M11 11V14M21 11C21 15.714 21 18.071 19.535 19.535C18.072 21 15.714 21 11 21C6.286 21 3.929 21 2.464 19.535C1 18.072 1 15.714 1 11C1 6.286 1 3.929 2.464 2.464C3.93 1 6.286 1 11 1C15.714 1 18.071 1 19.535 2.464C20.509 3.438 20.835 4.807 20.945 7"
      stroke="var(--start-color, #000)"
      strokeOpacity="0.9"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
